import axios from "axios";

const log = axios.create({
  baseURL: process.env.VUE_APP_LOG_SERVER,
  timeout: 60000,
});

export default log;
